import _ from 'lodash';
import ROLES from './roles';
import { sessionClaims } from './sessionClaims';

export default function getOrgFromToken() {
  const role = localStorage.getItem('role');
  const tokens = localStorage.getItem('tokens') ? JSON.parse(localStorage.getItem('tokens') || '') : {};
  const orgDetails = sessionClaims(tokens.access_token, tokens.id_token).organization;

  return role === ROLES.platAdmin ? { name: 'Dosen' } : orgDetails;
}

export const getUserDetails = (): {
  [x: string]: any;
  orgId: string;
  communicationUserId: string;
  ftue: boolean;
  name: string;
  location: string;
  userId: string;
  picture: string;
  email: string;
  coId: string;
  orgName: string;
  firstName: string;
  lastName: string;
  exp: number;
} => {
  const tokens = localStorage.getItem('tokens') ? JSON.parse(localStorage.getItem('tokens') || '') : {};
  if (_.size(tokens)) {
    // Claims from the tokens, or — transparent authentication — from the session profile.
    const {
      organization: orgDetails,
      userMetadata,
      accessData,
      idData
    } = sessionClaims(tokens.access_token, tokens.id_token);

    return {
      orgId: _.get(orgDetails, 'id', ''),
      communicationUserId: _.get(userMetadata, 'communicationId', ''),
      ftue: _.get(userMetadata, 'ftue', false),
      name: _.get(idData, 'name', ''),
      location: _.get(orgDetails, 'metadata.location', ''),
      orgName: _.get(orgDetails, 'name', ''),
      userId: _.get(idData, 'sub', ''),
      picture: _.get(userMetadata, 'headshot', ''),
      email: _.get(userMetadata, 'email', ''),
      coId: _.get(userMetadata, 'coId', ''),
      firstName: _.get(userMetadata, 'firstName', ''),
      lastName: _.get(userMetadata, 'lastName', ''),
      exp: _.get(accessData, 'exp', 0)
    };
  }
  return {
    orgId: '',
    communicationUserId: '',
    ftue: false,
    name: '',
    location: '',
    userId: '',
    picture: '',
    email: '',
    coId: '',
    orgName: '',
    firstName: '',
    lastName: '',
    exp: 0
  };
};
